import { useState } from 'react';
import styles from '../../assets/scss/components/NumericKeypad.module.scss';
import NumericKeypad from './NumericKeypad';

// Hiển thị giá trị thô: nhóm hàng nghìn bằng ",", giữ phần thập phân sau ".".
// Dùng chung cho cả số nguyên (không có ".") lẫn số thập phân.
function displayValue(value) {
    if (value === '' || value === null || value === undefined) return '';
    const [intPart = '', decPart] = String(value).split('.');
    const intNum = intPart.replace(/\D/g, '');
    if (!intNum && decPart === undefined) return '';
    const intFmt = intNum ? Number(intNum).toLocaleString('en-US') : '0';
    return decPart !== undefined ? `${intFmt}.${decPart}` : intFmt;
}

/**
 * Ô input read-only: bấm vào sẽ bung bàn phím số ảo thay vì bàn phím hệ điều hành.
 * Giữ nguyên giao diện .formInput sẵn có; onChange trả về chuỗi số thô như MoneyInput.
 *
 * @param {string}   title   Tiêu đề bàn phím (mặc định lấy theo placeholder).
 * @param {'money'|'integer'|'decimal'} mode  Kiểu nhập. Mặc định 'money'.
 * @param {boolean}  allowDecimal  Cho nhập thập phân. Mặc định true (đặt false để chặn).
 */
export default function KeypadInput({
    className,
    style,
    value,
    onChange,
    placeholder = '0',
    title,
    mode = 'money',
    allowDecimal = true,
    maxDecimals = 2,
    suffix,
    disabled,
    overlayClassName,
}) {
    const [open, setOpen] = useState(false);
    const shown = displayValue(value);

    return (
        <>
            <input
                className={`${className || ''} ${styles.trigger}`.trim()}
                style={style}
                type="text"
                readOnly
                value={shown}
                placeholder={placeholder}
                disabled={disabled}
                onClick={() => !disabled && setOpen(true)}
                onFocus={(e) => e.target.blur()}
            />
            <NumericKeypad
                open={open}
                title={title || placeholder || 'Nhập số'}
                value={value}
                mode={mode}
                allowDecimal={allowDecimal}
                maxDecimals={maxDecimals}
                suffix={suffix}
                overlayClassName={overlayClassName}
                onConfirm={(raw) => {
                    onChange?.(raw);
                    setOpen(false);
                }}
                onCancel={() => setOpen(false)}
            />
        </>
    );
}
